export const iconFontAwesomeWeatherTemperatureThreeQuarters = (
	<i className="fa-solid fa-temperature-three-quarters"></i>
);
